import { Phone, MessageCircle, MapPin, Mail, Clock } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SITE, waMenuLink } from "@/data/site";

export default function Contatti() {
  return (
    <section id="contatti" className="py-24 md:py-32 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <SectionHeading
          overline="Contatti"
          title={<>Vieni a <span className="italic text-terracotta">trovarci</span></>}
        />

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-7">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-terracotta/10 grid place-items-center text-terracotta shrink-0"><MapPin size={18} /></div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-charred/50">Indirizzo</p>
                  <p className="mt-1 font-serif text-2xl text-charred">{SITE.address}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-terracotta/10 grid place-items-center text-terracotta shrink-0"><Phone size={18} /></div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-charred/50">Telefono e WhatsApp</p>
                  <p className="mt-1 font-serif text-2xl text-charred">{SITE.phoneDisplay === SITE.whatsappDisplay ? SITE.phoneDisplay : `${SITE.phoneDisplay} · ${SITE.whatsappDisplay}`}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-terracotta/10 grid place-items-center text-terracotta shrink-0"><Mail size={18} /></div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-charred/50">E-mail</p>
                  <a href={`mailto:${SITE.email}`} data-testid="contact-email-link" className="mt-1 block font-serif text-2xl text-charred hover:text-terracotta transition-colors">{SITE.email}</a>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              <a href={SITE.phoneHref} data-testid="contact-call-btn"
                className="rounded-full bg-terracotta text-cream px-6 py-3 text-sm font-semibold hover:bg-terracotta-dark hover:-translate-y-0.5 transition-all duration-300 inline-flex items-center gap-2">
                <Phone size={15} /> Telefona
              </a>
              <a href={waMenuLink} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-btn"
                className="rounded-full bg-[#25D366] text-white px-6 py-3 text-sm font-semibold hover:brightness-95 hover:-translate-y-0.5 transition-all duration-300 inline-flex items-center gap-2">
                <MessageCircle size={15} /> Scrivi su WhatsApp
              </a>
              <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer" data-testid="contact-maps-btn"
                className="rounded-full border border-charred/30 text-charred px-6 py-3 text-sm font-semibold hover:bg-charred hover:text-cream hover:-translate-y-0.5 transition-all duration-300 inline-flex items-center gap-2">
                <MapPin size={15} /> Apri su Google Maps
              </a>
            </div>

            <p className="mt-8 text-xs text-charred/50 leading-relaxed max-w-xl">
              Gli ordini inviati tramite WhatsApp, e-mail o modulo online si considerano accettati solamente dopo la conferma da parte di SAPORÉ. La disponibilità dei prodotti può variare e alcune preparazioni potrebbero terminare nel corso della giornata.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="bg-sand rounded-lg p-8 md:p-10">
              <div className="flex items-center gap-3 text-charred">
                <Clock size={18} className="text-terracotta" />
                <h3 className="font-serif text-2xl">Orari di apertura</h3>
              </div>
              <ul className="mt-6 divide-y divide-charred/10" data-testid="opening-hours-list">
                {SITE.hours.map((h) => (
                  <li key={h.day} className="py-3 flex items-center justify-between text-sm md:text-base">
                    <span className="text-charred/80 font-medium">{h.day}</span>
                    <span className={h.time === "Chiuso" ? "text-terracotta font-semibold" : "text-charred/60"}>{h.time}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-5 text-xs text-charred/50">Gli orari possono subire variazioni durante festività e occasioni particolari.</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
